import OrderDetail from './OrderDetail'

export default OrderDetail
